
import * as defaultImport from "@splunk/react-ui/CollapsiblePanel";
export * from "@splunk/react-ui/CollapsiblePanel";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
